(() => {
    const swiperEl = document.querySelector('#tip-5-slider');
    const tabs = Array.from(document.querySelectorAll('.tab'));

    if (!swiperEl || tabs.length === 0) return;

    const swiper = new Swiper(swiperEl, {
        slidesPerView: 1,
        autoHeight: true,
        loop: false,
        observer: true,
        observeParents: true,
        breakpoints: {
            0: {
                effect: 'slide',
                fadeEffect: undefined,
            },
            768: {
                effect: 'fade',
                fadeEffect: { crossFade: true },
            }
        }
    });

    const updateActiveTab = (index) => {
        tabs.forEach((tab, i) => {
            tab.classList.toggle('is-active', i === index);
        });
    };

    const scrollActiveTabIntoView = () => {
        const activeTab = document.querySelector('.tabs-pad .tab.is-active');
        const tabsWrapper = document.querySelector('.tabs-pad');

        if (activeTab && tabsWrapper) {
            const tabOffsetLeft = activeTab.offsetLeft;
            const tabWidth = activeTab.offsetWidth;
            const wrapperScrollLeft = tabsWrapper.scrollLeft;
            const wrapperWidth = tabsWrapper.offsetWidth;

            const isTabFullyVisible =
                tabOffsetLeft >= wrapperScrollLeft &&
                (tabOffsetLeft + tabWidth) <= (wrapperScrollLeft + wrapperWidth);

            if (!isTabFullyVisible) {
                tabsWrapper.scrollTo({
                    left: tabOffsetLeft - 16,
                    behavior: 'smooth'
                });
            }
        }
    };

    tabs.forEach((tab, index) => {
        tab.addEventListener('click', (e) => {
            e.preventDefault();
            swiper.slideTo(index);
            updateActiveTab(index);
            scrollActiveTabIntoView();
        });
    });

    swiper.on('slideChangeTransitionEnd', () => {
        updateActiveTab(swiper.activeIndex);
        swiper.updateAutoHeight();
        scrollActiveTabIntoView();
    });

    setTimeout(() => {
        swiper.update();
        swiper.updateAutoHeight();
    }, 1000);
})();